import { useEffect, useMemo, useState } from "react";
import { ResourceView } from "../../../dto/ResourceView";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import {
  AvailabilitySource,
  useEResourceAvailability,
} from "../../../contexts/EResourceAvailabilityContext";

export function useDownloadableSource(resource: ResourceView | ResourceDWR) {
  const { getAvailabilityForEResource } = useEResourceAvailability();
  const [source, setSource] = useState<AvailabilitySource | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const hasDownloadbleCheckouts = useMemo(() => {
    return source?.canCheckout && source?.actionsEnabled;
  }, [source]);

  useEffect(() => {
    if (!resource) return;

    setLoading(true);
    getAvailabilityForEResource(resource.hostBibliographicId).then(
      (availabilitySource) => {
        setSource(availabilitySource);
        setLoading(false);
      }
    );
  }, [resource]);

  return {
    source,
    loading,
    hasDownloadbleCheckouts,
  };
}
